import PropTypes from "prop-types";
import { filterOptionShape } from "../../shapes";

/**
 * PropTypes for SelectedList chip renderer.
 *
 * @property {Array<FilterOption>} items - Currently selected options
 * @property {boolean} [unique] - When true, chips are read-only (no remove)
 * @property {boolean} [isWrapped] - Whether items wrap to multiple rows
 * @property {Function} onRemove - Handler called with (event, option) on remove
 */
export const selectedListPropTypes = {
  items: PropTypes.arrayOf(filterOptionShape).isRequired,
  unique: PropTypes.bool,
  isWrapped: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  padding: PropTypes.string,
  height: PropTypes.string,
};

/**
 * PropTypes for SelectedListLabel summary renderer.
 *
 * @property {Array<FilterOption>} items - Selected options
 * @property {string} [listLabel] - Label to display when showing a summary
 */
export const selectedListLabelPropTypes = {
  items: PropTypes.arrayOf(filterOptionShape).isRequired,
  listLabel: PropTypes.string,
};

/**
 * PropTypes for individual option list item.
 *
 * @property {FilterOption} option - Option to render
 * @property {boolean} [unique] - Hide checkbox when true
 * @property {Function} onClick - Click handler for selection
 */
export const optionItemPropTypes = {
  option: filterOptionShape.isRequired,
  unique: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};
